// import React, { useEffect, useState } from "react";
// import "../home/Home.css";
// import {
//   guideLogin,
//   guideForgotPassword,
//   guideVerifyOtp,
//   guideResetPassword,
// } from "../services/guideService";
// import { Modal } from "react-bootstrap";
// import { saveUserData } from "../utils/storage";
// import { useDispatch } from "react-redux";
// import { loginSuccess } from "../redux/slices/authSlice";
// import { useNavigate } from "react-router-dom";

// const GuideAuth = ({ show, onClose, setShowGuideLogin }) => {
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const [step, setStep] = useState(1);
//   const [emailOtp, setEmailOtp] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     email: "",
//     password: "",
//     newPassword: "",
//     confirmPassword: "",
//   });
//   const [errorMessage, setErrorMessage] = useState(null);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [resendTimer, setResendTimer] = useState(0);
// const [resending, setResending] = useState(false);

//   const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleLogin = async () => {
//     try {
//       setLoading(true);
//       const response = await guideLogin(formData);

//       if (response.success === true) {
//         dispatch(
//           loginSuccess({
//             user: response.user,
//             token: response.token,
//           }),
//         );

//         saveUserData("guide", response.user);
//         saveUserData("guide_token", response.token);
//         saveUserData("guide_refreshtoken", response.refreshToken);

//         saveUserData("guide_login_time", Date.now());

//         navigate("/guide-dashboard");
//         setShowGuideLogin(false);
//       }
//     } catch (err) {
//       console.error("Error in guide login", err.response);
//       setErrorMessage(
//         err?.response?.data?.message || "Login Failed, please try again.",
//       );
//     } finally {
//       setLoading(false);
//     }
//   };


//   const handleSendOtp = async () => {
//   try {
//     setLoading(true);

//     await guideForgotPassword({ email: formData.email });

//     setStep(3);

//     // ⏱️ Start 2 min timer
//     setResendTimer(120);
//   } catch (err) {
//     setErrorMessage(err.response?.data?.message);
//   } finally {
//     setLoading(false);
//   }
// };

// const handleResendOtp = async () => {
//   try {
//     setResending(true);

//     await guideForgotPassword({ email: formData.email });

//     setResendTimer(120); // reset timer
//     setSuccessMessage("OTP resent successfully");
//   } catch (err) {
//     setErrorMessage(err.response?.data?.message);
//   } finally {
//     setResending(false);
//   }
// };
//   const handleVerifyOtp = async () => {
//     try {
//       setLoading(true);
//       const resp = await guideVerifyOtp({
//         email: formData.email,
//         otp: emailOtp,
//       });
//       console.log("resp of guide verify otp", resp);
//       setStep(4);
//     } catch (err) {
//       setErrorMessage(err.response?.data?.message);
//       console.log("err in guide verify otp", err.response?.data);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleResetPassword = async () => {
//     try {
//       setLoading(true);
//       const resp = await guideResetPassword({
//         email: formData.email,
//         newPassword: formData.newPassword,
//         confirmPassword: formData.confirmPassword,
//       });
//       console.log("reps of guide reset password", resp);
//       setSuccessMessage("Password reset successfully");
//       setStep(1);
//     } catch (err) {
//       setErrorMessage(err.response?.data?.message);
//       console.log("err in guide reset paswrod", err.response?.data);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     if (!errorMessage) return;

//     const timer = setTimeout(() => {
//       setErrorMessage(null);
//     }, 5000);

//     return () => clearTimeout(timer);
//   }, [errorMessage]);
//   useEffect(() => {
//     if (!successMessage) return;

//     const timer = setTimeout(() => {
//       setSuccessMessage(null);
//     }, 5000);

//     return () => clearTimeout(timer);
//   }, [successMessage]);

//   useEffect(() => {
//   if (resendTimer <= 0) return;

//   const timer = setInterval(() => {
//     setResendTimer((prev) => prev - 1);
//   }, 1000);

//   return () => clearInterval(timer);
// }, [resendTimer]);

//   return (
//     <Modal
//       show={show}
//       onHide={() => setShowGuideLogin(false)}
//       backdrop="static"
//       keyboard={false}
//       centered
//     >
//       {/* Modal Header */}
//       <Modal.Header closeButton>
//         <Modal.Title>Guide Login</Modal.Title>
//       </Modal.Header>

//       {/* Modal Body */}
//       <Modal.Body>
//         <>
//           <p className="text-center text-muted mb-3">
//             Plan your trip, manage bookings, and access everything with
//             <strong> Safarix</strong>
//           </p>

//           {errorMessage && (
//             <small style={{ color: "red" }}>{errorMessage}</small>
//           )}
//           {successMessage && (
//             <small style={{ color: "green" }}>{successMessage}</small>
//           )}

//           {/* ================= LOGIN ================= */}
//           {step === 1 && (
//             <>
//               {/* Email */}
//               <div className="mb-3">
//                 <div className="input-wrapper">
//                   <input
//                     type="email"
//                     placeholder="Email address"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               {/* Password */}
//               <div className="mb-3 position-relative">
//                 <div className="input-wrapper">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     placeholder="Password"
//                     name="password"
//                     value={formData.password}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <span
//                   className="position-absolute"
//                   style={{
//                     right: "10px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                     cursor: "pointer",
//                   }}
//                   onClick={() => setShowPassword((prev) => !prev)}
//                 >
//                   <i
//                     className={`bi ${
//                       showPassword ? "bi-eye-slash-fill" : "bi-eye-fill"
//                     }`}
//                   ></i>
//                 </span>
//               </div>

//               {/* Login Button */}
//               <div className="mb-3">
//                 <button
//                   className={`explore-btn ${
//                     isValidEmail(formData.email)
//                       ? "btn-primary text-white"
//                       : "btn-light text-muted"
//                   }`}
//                   disabled={!isValidEmail(formData.email)}
//                   onClick={handleLogin}
//                 >
//                   {loading ? "Processing..." : "Login"}
//                 </button>
//               </div>

//               <div className="row">
//                 <div className="col">
//                   <button
//                     className="btn btn-link p-0 small text-muted"
//                     onClick={() => setStep(2)}
//                   >
//                     Forgot Your Password?
//                   </button>
//                 </div>
//                 <div className="col text-end">
//                   <button
//                     className="btn btn-link p-0 small text-muted"
//                     onClick={() => {
//                       setShowGuideLogin(false);
//                       navigate("/guide-careers");
//                     }}
//                   >
//                     New Guide?
//                   </button>
//                 </div>
//               </div>
//             </>
//           )}

//           {/* ================= ENTER EMAIL ================= */}
//           {step === 2 && (
//             <>
//               <div className="mb-3">
//                 <div className="input-wrapper">
//                   <input
//                     type="email"
//                     placeholder="Email address"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               <div className="mb-3">
//                 <button
//                   className="explore-btn"
//                   disabled={!formData.email || loading}
//                   onClick={handleSendOtp}
//                 >
//                   {loading ? "Processing..." : "Send OTP"}
//                 </button>
//               </div>

//               <div className="row">
//                 <div className="col">
//                   <button
//                     className="btn btn-link p-0 small text-muted"
//                     onClick={() => setStep(1)}
//                   >
//                     Back to login
//                   </button>
//                 </div>
//               </div>
//             </>
//           )}

//           {/* ================= OTP ================= */}
//           {step === 3 && (
//             <>
//               <p className="text-muted text-center">
//                 We’ve sent a verification code to {formData.email}
//               </p>

//               <div className="mb-3">
//                 <input
//                   type="text"
//                   className="form-control"
//                   placeholder="Enter 4-digit OTP"
//                   value={emailOtp}
//                   maxLength={4}
//                   onChange={(e) => setEmailOtp(e.target.value)}
//                 />
//               </div>

//               <div className="mb-3">
//                 <button
//                   className={`explore-btn ${
//                     emailOtp.length === 4
//                       ? "btn-primary text-white"
//                       : "btn-light text-muted"
//                   }`}
//                   disabled={emailOtp.length !== 4 || loading}
//                   onClick={handleVerifyOtp}
//                 >
//                   {loading ? "Processing..." : "Verify OTP"}
//                 </button>
//               </div>

//               <div className="text-center mt-3">
//   {resendTimer > 0 ? (
//     <small className="text-muted">
//       Resend OTP in {Math.floor(resendTimer / 60)}:
//       {String(resendTimer % 60).padStart(2, "0")}
//     </small>
//   ) : (
//     <button
//       className="btn btn-link p-0"
//       disabled={resending}
//       onClick={handleResendOtp}
//     >
//       {resending ? "Resending..." : "Resend OTP"}
//     </button>
//   )}
// </div>
//             </>
//           )}

//           {/* ================= RESET PASSWORD ================= */}
//           {step === 4 && (
//             <>
//               <h5 className="text-center mb-2">Reset Password</h5>

//               <div className="mb-3 position-relative">
//                 <div className="input-wrapper">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     placeholder="New Password"
//                     name="newPassword"
//                     value={formData.newPassword}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               <div className="mb-3">
//                 <div className="input-wrapper">
//                   <input
//                     type="password"
//                     placeholder="Confirm Password"
//                     name="confirmPassword"
//                     value={formData.confirmPassword}
//                     onChange={handleChange}
//                   />
//                 </div>
//               </div>

//               <div className="mb-3">
//                 <button
//                   className="explore-btn btn-primary text-white"
//                   disabled={
//                     !formData.newPassword ||
//                     !formData.confirmPassword ||
//                     loading
//                   }
//                   onClick={handleResetPassword}
//                 >
//                   {loading ? "Processing..." : "Reset Password"}
//                 </button>
//               </div>
//             </>
//           )}
//         </>
//       </Modal.Body>

//       {/* Modal Footer */}
//       <Modal.Footer className="flex-column">
//         <p className="text-center small text-muted mb-0">
//           By signing in, you accept our{" "}
//           <a href="/terms-conditions">
//             <strong className="fs-6">Terms and Conditions</strong>
//           </a>{" "}
//           and{" "}
//           <a href="/privacy-policy">
//             <strong className="fs-6">Privacy Policy</strong>
//           </a>
//           .
//         </p>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default GuideAuth;


import React, { useEffect, useState } from "react";
import {
  guideLogin,
  guideForgotPassword,
  guideVerifyOtp,
  guideResetPassword,
} from "../services/guideService";
import { saveUserData } from "../utils/storage";
import { useDispatch } from "react-redux";
import { loginSuccess } from "../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import "./GuideAuth.css";

const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

const GuideAuth = ({ show, onClose, setShowGuideLogin }) => {
  const navigate  = useNavigate();
  const dispatch  = useDispatch();

  const [step,            setStep]            = useState(1);
  const [showPassword,    setShowPassword]    = useState(false);
  const [emailOtp,        setEmailOtp]        = useState("");
  const [loading,         setLoading]         = useState(false);
  const [resendTimer,     setResendTimer]     = useState(0);
  const [resending,       setResending]       = useState(false);
  const [errorMessage,    setErrorMessage]    = useState(null);
  const [successMessage,  setSuccessMessage]  = useState(null);

  const [formData, setFormData] = useState({
    email: "", password: "", newPassword: "", confirmPassword: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const closeModal = () => {
    setShowGuideLogin(false);
    onClose?.();
  };

  // ── Auto-clear messages ──────────────────────────────────────────────
  useEffect(() => {
    if (!errorMessage) return;
    const t = setTimeout(() => setErrorMessage(null), 5000);
    return () => clearTimeout(t);
  }, [errorMessage]);

  useEffect(() => {
    if (!successMessage) return;
    const t = setTimeout(() => setSuccessMessage(null), 5000);
    return () => clearTimeout(t);
  }, [successMessage]);

  // ── Resend OTP countdown ─────────────────────────────────────────────
  useEffect(() => {
    if (resendTimer <= 0) return;
    const t = setInterval(() => setResendTimer((p) => p - 1), 1000);
    return () => clearInterval(t);
  }, [resendTimer]);

  // ── Handlers ─────────────────────────────────────────────────────────
  const handleLogin = async () => {
    try {
      setLoading(true);
      const res = await guideLogin(formData);
      if (res.success) {
        dispatch(loginSuccess({ user: res.user, token: res.token }));
        saveUserData("guide",              res.user);
        saveUserData("guide_token",        res.token);
        saveUserData("guide_refreshtoken", res.refreshToken);
        saveUserData("guide_login_time",   Date.now());
        navigate("/guide-dashboard");
        closeModal();
      }
    } catch (err) {
      setErrorMessage(err?.response?.data?.message || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleSendOtp = async () => {
    try {
      setLoading(true);
      await guideForgotPassword({ email: formData.email });
      setStep(3);
      setResendTimer(120);
    } catch (err) {
      setErrorMessage(err.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setResending(true);
      await guideForgotPassword({ email: formData.email });
      setResendTimer(120);
      setSuccessMessage("OTP resent successfully.");
    } catch (err) {
      setErrorMessage(err.response?.data?.message);
    } finally {
      setResending(false);
    }
  };

  const handleVerifyOtp = async () => {
    try {
      setLoading(true);
      await guideVerifyOtp({ email: formData.email, otp: emailOtp });
      setStep(4);
    } catch (err) {
      setErrorMessage(err.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async () => {
    try {
      setLoading(true);
      await guideResetPassword({
        email:           formData.email,
        newPassword:     formData.newPassword,
        confirmPassword: formData.confirmPassword,
      });
      setSuccessMessage("Password reset successfully.");
      setStep(1);
    } catch (err) {
      setErrorMessage(err.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  const stepLabels = ["Login", "Forgot Password", "Verify OTP", "Reset Password"];

  return (
    <div
      className="ga-overlay"
      onClick={(e) => { if (e.target === e.currentTarget) closeModal(); }}
    >
      <div className="ga-box">

        {/* ── Header ── */}
        <div className="ga-header">
          <div className="ga-header-left">
            <div className="ga-logo-dot">🧭</div>
            <div>
              <div className="ga-header-title">Guide</div>
              <div className="ga-header-sub">{stepLabels[step - 1]}</div>
            </div>
          </div>
          <button className="ga-close" onClick={closeModal}>×</button>
        </div>

        {/* ── Step indicator ── */}
        <div className="ga-steps">
          {[1, 2, 3, 4].map((s) => (
            <div key={s} className={`ga-step ${step >= s ? "ga-step--done" : ""}`} />
          ))}
        </div>

        {/* ── Body ── */}
        <div className="ga-body">

          {/* Messages */}
          {errorMessage && (
            <div className="ga-alert ga-alert--error">{errorMessage}</div>
          )}
          {successMessage && (
            <div className="ga-alert ga-alert--success">{successMessage}</div>
          )}

          {/* ─── STEP 1 — Login ─── */}
          {step === 1 && (
            <>
              <p className="ga-tagline">
                Manage your bookings and clients with <strong>Safarix</strong>
              </p>

              <div className="ga-field">
                <label className="ga-label">Email address</label>
                <input
                  className="ga-input"
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <div className="ga-field">
                <label className="ga-label">Password</label>
                <div className="ga-input-wrap">
                  <input
                    className="ga-input"
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Enter your password"
                    value={formData.password}
                    onChange={handleChange}
                  />
                  <button
                    className="ga-eye"
                    type="button"
                    onClick={() => setShowPassword((p) => !p)}
                    tabIndex={-1}
                  >
                    {showPassword ? "🙈" : "👁"}
                  </button>
                </div>
              </div>

              <button
                className="ga-btn ga-btn--primary"
                disabled={!isValidEmail(formData.email) || !formData.password || loading}
                onClick={handleLogin}
              >
                {loading ? <span className="ga-spinner" /> : null}
                {loading ? "Signing in…" : "Login"}
              </button>

              <div className="ga-links">
                <button className="ga-link" onClick={() => setStep(2)}>
                  Forgot password?
                </button>
                <button
                  className="ga-link"
                  onClick={() => { closeModal(); navigate("/guide-careers"); }}
                >
                  New Guide? Apply →
                </button>
              </div>
            </>
          )}

          {/* ─── STEP 2 — Enter email ─── */}
          {step === 2 && (
            <>
              <p className="ga-tagline">
                Enter your registered email to receive an OTP.
              </p>

              <div className="ga-field">
                <label className="ga-label">Email address</label>
                <input
                  className="ga-input"
                  type="email"
                  name="email"
                  placeholder="you@example.com"
                  value={formData.email}
                  onChange={handleChange}
                />
              </div>

              <button
                className="ga-btn ga-btn--primary"
                disabled={!isValidEmail(formData.email) || loading}
                onClick={handleSendOtp}
              >
                {loading ? <span className="ga-spinner" /> : null}
                {loading ? "Sending…" : "Send OTP"}
              </button>

              <div className="ga-links">
                <button className="ga-link" onClick={() => setStep(1)}>
                  ← Back to login
                </button>
              </div>
            </>
          )}

          {/* ─── STEP 3 — OTP ─── */}
          {step === 3 && (
            <>
              <p className="ga-tagline">
                We've sent a 4-digit code to <strong>{formData.email}</strong>
              </p>

              <div className="ga-field">
                <label className="ga-label">OTP Code</label>
                <input
                  className="ga-input ga-input--otp"
                  type="text"
                  inputMode="numeric"
                  maxLength={4}
                  placeholder="• • • •"
                  value={emailOtp}
                  onChange={(e) => setEmailOtp(e.target.value.replace(/\D/, ""))}
                />
              </div>

              <button
                className="ga-btn ga-btn--primary"
                disabled={emailOtp.length !== 4 || loading}
                onClick={handleVerifyOtp}
              >
                {loading ? <span className="ga-spinner" /> : null}
                {loading ? "Verifying…" : "Verify OTP"}
              </button>

              <div className="ga-resend">
                {resendTimer > 0 ? (
                  <span className="ga-resend-timer">
                    Resend OTP in {Math.floor(resendTimer / 60)}:
                    {String(resendTimer % 60).padStart(2, "0")}
                  </span>
                ) : (
                  <button
                    className="ga-link"
                    disabled={resending}
                    onClick={handleResendOtp}
                  >
                    {resending ? "Resending…" : "Resend OTP"}
                  </button>
                )}
              </div>
            </>
          )}

          {/* ─── STEP 4 — Reset password ─── */}
          {step === 4 && (
            <>
              <p className="ga-tagline">Choose a strong new password.</p>

              <div className="ga-field">
                <label className="ga-label">New Password</label>
                <div className="ga-input-wrap">
                  <input
                    className="ga-input"
                    type={showPassword ? "text" : "password"}
                    name="newPassword"
                    placeholder="New password"
                    value={formData.newPassword}
                    onChange={handleChange}
                  />
                  <button
                    className="ga-eye"
                    type="button"
                    onClick={() => setShowPassword((p) => !p)}
                    tabIndex={-1}
                  >
                    {showPassword ? "🙈" : "👁"}
                  </button>
                </div>
              </div>

              <div className="ga-field">
                <label className="ga-label">Confirm Password</label>
                <input
                  className="ga-input"
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm new password"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                />
              </div>

              <button
                className="ga-btn ga-btn--primary"
                disabled={!formData.newPassword || !formData.confirmPassword || loading}
                onClick={handleResetPassword}
              >
                {loading ? <span className="ga-spinner" /> : null}
                {loading ? "Resetting…" : "Reset Password"}
              </button>
            </>
          )}

        </div>
        {/* end ga-body */}

        {/* ── Footer ── */}
        <div className="ga-footer">
          By signing in, you accept our{" "}
          <a href="/terms-conditions" className="ga-footer-link">Terms & Conditions</a>
          {" "}and{" "}
          <a href="/privacy-policy" className="ga-footer-link">Privacy Policy</a>.
        </div>

      </div>
    </div>
  );
};

export default GuideAuth;